// extracted by mini-css-extract-plugin
export var inlineLink = "_ap-0";
export var inlineLinkButton = "_ap-1";